module.exports = __webpack_public_path__ + "img/nz.00141efe.svg";